import React, { useState, useEffect } from "react";
import { fromJS } from "immutable";
import { connect } from "react-redux";
import { Form, Field, reduxForm, destroy } from "redux-form";
import { ToastContainer, toast } from "react-toastify";
import VerifyMobile from "../../components/salesUser/campaign/verifymobilejs";

import "react-toastify/dist/ReactToastify.css";
import {
  InputContact,
  DropDownContact,
  DropDown,
  DropDownContactDistrict,
} from "../common/input";
import { getState } from "../../action/user_action";
import Footer from "../common/Footer";
import { scrollHandler, goToByScroll } from "../../util/animation";
import Header from "../common/Header";
import { axiosInstnace as Axios } from "../../util/util";
import { endPoints } from "../../config";
import { history } from "../../history/history";
import {
  phoneNumber,
  email,
  string,
  maxLengthCheck,
} from "../../util/validate";
import AOS from "aos";

import Popup from "react-popup";

const Contact = (props) => {
  //Define the initial state.
  const [stateList, handleCityState] = useState([]);
  const [cityList, handleCity] = useState([]);
  const [message, handleMessage] = useState("");
  const [districtList, handleDistrict] = useState([]);
  const [arrow2, handleArrow2] = useState("select_state");
  const [inputArray, handleInputArray] = useState([]);
  const [verify, setVerify] = useState(false);
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [state, setState]= useState("")
  const [city, setCity] = useState("")

  //Initialize the scroll function
  useEffect(() => {
    window.addEventListener("scroll", scrollHandler);
    props.getState();
    AOS.init({
      duration: 600,
    });
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  const handleStateCity = async (state) => {
    const response = await Axios.get(`${endPoints.getCities}?state=${state}`);
    console.log(response.data.data.data);
    let cityList = response.data.data.data;
    handleCityItems(cityList);
  };
  const handleverifypopup = (e) => {
    setVerify(!verify);
  };

  const handleCityItems = (cityList) => {
    let cityListItems = cityList.map((d) => ({
      name: d.city,
      value: d.city,
    }));
    console.log(cityListItems);
    handleCity(fromJS(cityListItems));
  };

  //Fetch the state list from backend
  useEffect(() => {
    if (props.stateList && props.stateList.size > 0) {
      console.log(props.stateList.size);
      console.log(props.stateList[props.stateList.size]);
      props.stateList[props.stateList.size] = "Outside India";
      console.log(props.stateList);
      let stateList = props.stateList.toJS().map((s) => ({
        name: s,
        value: s,
      }));
      handleCityState(fromJS(stateList));
    }
  }, [props.stateList]);

  /**
   * Submit the contact form that
   * containing the info object about the contact.
   */
  const handleSubmit = async (e) => {
    e.preventDefault()
   if (!name || !company || !email || !mobile || !state || !city || !message ) {
      toast.error("All fields are mandatory", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    } 
    if (!mobile.match(/^[6789]\d{9}$/)) {
      toast.error("Please enter a valid Phone Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
      return;
    }
    setVerify(!verify);
  };
  const addContact = async()=>{
    setVerify(!verify)
    let params = {
      name,email,mobile,state,city,company,
      message,
      status: "Open",
    };

    if(props.location.search != ''){
      let splashid = new URLSearchParams(props.location.search).get('splashid');
      if(splashid){
        params.splashid = splashid;
      }
    }
    
    try {
      const data = await Axios.post(endPoints.contact, params);
      const result = data.data.data.data;
      if (result) {
        props.destroyForm("contact");
        handleMessage("");
        toast.error("Thank You for connecting us,We will respond soon", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: false,
          hideProgressBar: true,
          toastId: "1",
        });
        setTimeout(() => {
          history.push("");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
    }
  }

  //Getting the contat message
  const getMessage = (e) => {
    let message = e.target.value;
    if (message.length < 175) {
      handleMessage(message);
    } else {
      return;
    }
  };

  const handleStateDistrict = async (state) => {
    const response = await Axios.get(
      `${endPoints.getDistrictList}?state=${state}`
    );
    console.log(response.data.data.data);
    let districtList = response.data.data.data;
    handleDistrictItems(districtList);
  };

  const handleDistrictItems = (districtList) => {
    let districtListItems = districtList.map((d) => ({
      name: d.district,
      value: d.district,
    }));
    console.log(districtListItems);
    handleDistrict(fromJS(districtListItems));
  };

  const handleArrowChange = (e) => {
    console.log(e.target.value);
    handleStateCity(e.target.value);
    setState(e.target.value)
  };

  const handleArrowClick2 = () => {
    handleArrow2("select_state dropdown_open");
  };

  const handleArrowChange2 = (e) => {
    console.log(inputArray);
    console.log(e.target.value);
    handleArrow2("select_state");
    handleInputArray(inputArray);
  };

  //Return the contact text
  return (
    <div className="main_wrapper contact-wrapper">
      <Header active={true} withoutSticky={true} />
      <div className="contactus_top"></div>
      <div className="contactus_bottom_wrapper">
        <div className="contactus_form_wrapper">
          <div className="contact_header">
            <div className="contactgrid-img">
              <img src="../../assets/images/dots.png" />
            </div>
            <div className="contact_card_text">
              <div className="text_inner">
                CONTACT <span>US</span>
              </div>
            </div>
          </div>
          <div className="form_wrapper">
            <p className="form_header">
              Fill the form below. We will get in touch with you as soon as we
              can!
            </p>
            <div className="contact_form">
              {/* <form className="contact_form"> */}
              <Form className="contact_form">
                <div className="form_left_wrapper">
                  <div className="form_left">
                    <div className="contact_field">
                      <div className="contact_label">
                        <label>Name</label>
                      </div>
                      <div className="contact_input">
                        <input
                          type="text"
                          name="name"
                          placeholder="Enter your name"
                        value={name}
                        onChange={(e)=>{
                          setName(e.target.value)
                        }}
                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label">
                        <label>Email ID</label>
                      </div>
                      <div className="contact_input">
                        {/* <input type="email" placeholder="Enter valid email id"/> */}
                        <input
                          type="text"
                          name="email"
                          placeholder="Enter valid email id"
value={email}
onChange={(e)=>{
  setEmail(e.target.value)
}}
/>

                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label">
                        <label>Mobile</label>
                      </div>
                      <div className="contact_input">
                        {/* <input type="text" placeholder="Enter your mobile number" /> */}
                        <input
                          type="text"
                          name="mobile"
                          placeholder="Enter your mobile number"
                          value={mobile}
                          onChange={(e)=>[
                            setMobile(e.target.value)
                          ]}
                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label">
                        <label>Company Name</label>
                      </div>
                      <div className="contact_input">
                        {/* <input type="text" placeholder="Enter the company name" /> */}
                        <input
                          type="text"
                          name="company"
                          placeholder="Enter the company name"
                          value={company}
                          onChange={(e)=>{
                            setCompany(e.target.value)
                          }}
                        />
                      </div>
                    </div>
                    <div className="contact_field">
                      <div className="contact_label">
                        <label>State</label>
                      </div>
                      <div className="contact_input">
                        <Field
                          type="text"
                          name="state"
                          label="State"
                          component={DropDownContact}
                          options={stateList}
                          onChange={handleArrowChange}
                        />
                      </div>
                    </div>

                    <div className="contact_field">
                      <div className="contact_label">
                        <label>City</label>
                      </div>
                      <div className="contact_input">
                        <Field
                          type="text"
                          name="city"
                          label="City"
                          component={DropDownContactDistrict}
                          options={cityList}
                          onChange={(e)=>{
                            setCity(e.target.value)
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="contact_submit">
                    <button onClick={handleSubmit}>SUBMIT</button>
                  </div>
                </div>
                <div className="form_right">
                  <div className="contact_label">
                    <label>Your Message</label>
                  </div>
                  <textarea
                    placeholder="Anything you'd like to share..."
                    value={message}
                    onChange={getMessage.bind(this)}
                  ></textarea>
                </div>
              </Form>
            </div>
          </div>
          {verify && (
            <VerifyMobile
              hide={handleverifypopup}
              isShowing={true}
              mobile={mobile}
              verify={addContact}
            />
          )}
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => ({ stateList: state.user.get("stateList") });

export default connect(mapStateToProps, { getState, destroyForm: destroy })(
  reduxForm({
    form: "contact",
  })(Contact)
);

// export default Contact;



// WEBPACK FOOTER //
// ./web/components/contact/index.js